module.exports = function() {
  return new Worker(__webpack_public_path__ + "74b83f862896d318eae7.worker.js");
};